import { createAction } from '@reduxjs/toolkit';
import type {
  ExportPdfLocationParams, ExportPdfPolygonParams,
} from '~/store/mapSettings/toolsState/exportPdf/exportPdfToolState.state';

export const exportPdfEnable = createAction(
  'MAP_SETTINGS_EXPORT_PDF_ENABLE',
  (params: ExportPdfLocationParams | ExportPdfPolygonParams) => ({
    payload: { params },
  })
);

export const exportPdfDisable = createAction(
  'MAP_SETTINGS_EXPORT_PDF_DISABLE',
);
